<template>
  <div class="ui blue inverted masthead center aligned segment">
    <img class="ui image" :src="image" />
    <div class="ui container">
      <h1 class="ui">
        Sorry, we couldn't find any active subscriptions for your account.
      </h1>
      <h2>
        Please contact your Client Success Manager or BizLibrary Support at
        1-888-315-8707.
      </h2>
      <router-link :to="{ name: 'logout' }" class="ui huge inverted button"
        >Sign Out</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'Expired',
  title: 'BizLibrary CDS',
  data() {
    return {
      image: require('@/assets/roped-door_bwg.png'),
    };
  },
};
</script>
